// extracted by mini-css-extract-plugin
export default {"menu__icon":"HamburgerMenu_menu__icon__84X35","menu-container":"HamburgerMenu_menu-container__wwplA","menu-container--hidden":"HamburgerMenu_menu-container--hidden__OxPnS"};